import { useState, useEffect } from "react"
import { Checkbox } from "@nextui-org/react"
import { getCategories } from "common/src/api/categories"

interface Category {
  id: number
  name: string
  description: string | null
}

interface CategorySelectorProps {
  selectedIds: number[]
  onChange: (ids: number[]) => void
}

export default function CategorySelector({ selectedIds = [], onChange }: CategorySelectorProps) {
  const [categories, setCategories] = useState<Category[]>([])

  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await getCategories()

      if (error) {
        console.error("Error fetching categories:", error)
        return
      }

      setCategories(data || [])
    }

    fetchCategories()
  }, [])

  const handleToggle = (categoryId: number) => {
    const newSelection = selectedIds.includes(categoryId)
      ? selectedIds.filter(id => id !== categoryId)
      : [...selectedIds, categoryId]
    
    onChange(newSelection)
  }

  return (
    <div className="flex flex-col gap-2 max-h-[200px] overflow-y-auto border border-gray-300 rounded-lg p-2">
      {categories.map((category) => (
        <Checkbox
          key={category.id}
          isSelected={selectedIds.includes(category.id)}
          onValueChange={() => handleToggle(category.id)}
          aria-label={category.name}
        >
          {category.name}
        </Checkbox>
      ))}
    </div>
  )
} 